<script>
   /*****************************************************************/
   /* Axes                                                          */
   /* --------------------                                          */
   /* modified version of Axes for the apps                         */
   /*****************************************************************/

   import { XAxis, YAxis, Box, Axes } from 'svelte-plots-basic/2d';
   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES, MARGINS } from './Defaults.js';
   import { escapeText } from '../utils.js';

   let {
      title,                // plot title
      limX,                 // x-axis limits
      limY,                 // y-axis limits
      xLabel,
      yLabel,
      whole = false,
      fileName,
      downloadCSVCallback = null,
      children,
      ...others
   } = $props();
   const plotActions = $derived(downloadCSVCallback ? [{'text': '↓ csv', callback: downloadCSVCallback}] : null)
</script>


<Axes title={escapeText(title)} {limX} {limY} {fileName} {plotActions} downloadLinks="hover"
   margins={MARGINS} pngWidth={PNG_WIDTH} pngHeight={PNG_HEIGHT} pngRes={PNG_RES}
   {...others}
>
   {@render children()}
   <XAxis showGrid={true} label={escapeText(xLabel)} {whole} />
   <YAxis showGrid={true} label={escapeText(yLabel)} />
   <Box />
</Axes>
